/**
 * @fileoverview Post Field Configuration - The field configuration of a post. Includes character limits
 * and excluded fields
 *
 * @author Samantha Landen (slanden@yext.com)
 */
goog.module('yext.social.post.PostFieldConfiguration');
goog.module.declareLegacyNamespace();

const Partner = goog.require('yext.social.post.Partner');

/** @constructor */
const PostFieldConfiguration = function(partners, postablePartners) {
  /** @type {Map} */
  var partnersMap = new Map();
  var availablePartners = [];
  (partners || []).forEach(function(partner) {
    partnersMap.set(partner['id'], new Partner(partner));
    availablePartners.push(partner['id']);
  });
  this.partners = partnersMap;

  /** @type {!Array<number>} */
  this.availablePartners = availablePartners;

  /** @type {!Array<number>} */
  this.postablePartners = postablePartners;
};

/** @param {!Array<number>} partnerIds */
PostFieldConfiguration.prototype.setAvailablePartners = function(partnerIds) {
  this.availablePartners = partnerIds;
};

/** @return {!Array<number>} partnerIds */
PostFieldConfiguration.prototype.getAvailablePartners = function(partnerIds) {
  return this.availablePartners;
};

PostFieldConfiguration.prototype.updatePartner = function(partner) {
  this.partners.set(partner['id'], partner);
};

/** @return {number} The highest min character limit for the partners */
PostFieldConfiguration.prototype.getEffectiveMinCharLimit = function() {
  return this.postablePartners.filter(function(partnerId) {
    let partner = this.partners.get(partnerId);
    return partner != null && partner.get('isSelected') && partner.get('isAvailable') && partner.get('minChars') != null;
  }.bind(this)).map(function(partnerId) {
    return this.partners.get(partnerId).get('minChars');
  }.bind(this)).reduce(function(a, b) {
    return Math.max(a, b);
  }, 0);
};

/**
 * @param {number} limit
 * @return {!Array<Partner} list of partners with the given min char limit
 */
PostFieldConfiguration.prototype.getPartnersWithMinCharLimit = function(limit) {
  return this.postablePartners.map(function(partnerId) {
    return this.partners.get(partnerId);
  }.bind(this)).filter(function(partner) {
    return partner != null && partner.get('isSelected') && partner.get('isAvailable') && partner.get('minChars') == limit;
  });
};

/**
 * @param {!Object<?, String>} post
 * @return {number} The lowest max character limit for the partners
 */
PostFieldConfiguration.prototype.getEffectiveMaxCharLimit = function(post) {
  return this.postablePartners.filter(function(partnerId) {
    let partner = this.partners.get(partnerId);
    return partner != null && partner.get('isSelected') && partner.get('isAvailable') && partner.getMaxChars(post) != null;
  }.bind(this)).map(function(partnerId) {
    return this.partners.get(partnerId).getMaxChars(post);
  }.bind(this)).reduce(function(a, b) {
    return Math.min(a, b);
  }, 5000);
};

/**
 * @param {Partner.PostField} field
 * @return {boolean} true if the field is allowed for the current field config
 */
PostFieldConfiguration.prototype.isFieldAllowed = function(field) {
  return this.availablePartners.filter(function(partnerId) {
    var partner = this.partners.get(partnerId);
    return partner != null && partner.get('excludedFields').includes(field);
  }.bind(this)).length == 0;
};

/**
 * @param {Partner.PostField} field
 * @return {boolean} true if the field is allowed for any of the postable partners
 */
PostFieldConfiguration.prototype.isFieldAllowedForAnyPartner = function(field) {
  return this.postablePartners.filter(function(partnerId) {
    var partner = this.partners.get(partnerId);
    return partner != null && !partner.get('excludedFields').includes(field);
  }.bind(this)).length > 0;
};

exports = PostFieldConfiguration;
